/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useState } from 'react';

import { CommentEditor } from './CommentEditor';

interface CommentBoxProps {
  onSubmit: (content: string) => Promise<void>;
  /** sessionStorage key used to persist the draft so content survives re-renders / unmounts */
  draftKey?: string;
}

export const CommentBox: React.FC<CommentBoxProps> = ({ onSubmit, draftKey }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = useCallback(
    async (content: string) => {
      if (!content.trim() || isSubmitting) return;

      setIsSubmitting(true);
      try {
        await onSubmit(content.trim());
      } finally {
        setIsSubmitting(false);
      }
    },
    [isSubmitting, onSubmit],
  );

  const handleCancel = useCallback(() => {
    // No specific cancel action needed for CommentBox itself, as it's always visible
    // The editor handles its own state internally.
  }, []);

  return (
    <div className="relative">
      <CommentEditor onSave={handleSubmit} onCancel={handleCancel} draftKey={draftKey} />
    </div>
  );
};
